import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MessageHeader = styled(Typography)`
  margin-bottom: 0.8rem;
`;
